import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import "./colaboradores.scss"

export const ColaboradoresSection = () => {
  return (
    <>
      <section
        className="servicios-colaboradores-container"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <div className="servicios-colaboradores-info-container">
          <div className="servicios-colaboradores-info-text">
            <h2>
              Contamos con personal propio y una amplia
              <span> red de colaboradores externos</span>
            </h2>
            <p>
              Todos ellos expertos profesionales equipados con tecnología de
              última generación, garantizamos cobertura nacional, las mejores
              soluciones y la máxima calidad en cada proyecto.
            </p>
          </div>
        </div>
        <div className="servicios-colaboradores-image-container">
          <StaticImage
            src="../../../../images/servicios/colaboradores/personal.png"
            className="servicios-colaboradores-image1"
            alt="colaboradores imagen 1"
          />
        </div>
      </section>
    </>
  )
}
